import validation from '@/mixins/validation';
import { email, minLength, required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  name: 'ContactsForm',
  mixins: [validation],
  data() {
    return {
      payload: {
        name: '',
        phone: '',
        email: '',
        comment: ''
      },
      validationErrors: {},
      isLoading: false
    };
  },
  validations() {
    return {
      payload: {
        name: {
          required
        },
        phone: {
          required,
          minLength: minLength(12)
        },
        email: {
          required,
          email
        },
        comment: {
          required
        }
      }
    };
  },
  computed: {
    nameErrors() {
      return this.computeErrors('payload', 'name', {
        required: 'validation.required'
      });
    },
    phoneErrors() {
      return this.computeErrors('payload', 'phone', {
        required: 'validation.required',
        minLength: { message: 'validation.minLength', options: { size: 12 } }
      });
    },
    emailErrors() {
      return this.computeErrors('payload', 'email', {
        required: 'validation.required',
        email: 'validation.email'
      });
    },
    commentErrors() {
      return this.computeErrors('payload', 'comment', {
        required: 'validation.required'
      });
    }
  },
  methods: {
    ...mapActions({
      sendContactForm: 'staticPages/SEND_CONTACT_FORM'
    }),
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isLoading = true;
        this.sendContactForm(this.payload)
          .then(() => {
            this.$toasted.success(this.$t('page.contacts.formMessageSuccess'));
            this.$v.$reset();
            this.payload = {
              name: '',
              lastName: '',
              email: '',
              comment: ''
            };
          })
          .catch(() => {
            this.$toasted.error(this.$t('page.contacts.formMessageError'));
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    }
  }
};
